<template>
  <div v-if="body" class="bg-light">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs">
          <div class="page-content" v-html="body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config';

const { endpoints } = config.page;

export default {
  name: 'Info',
  data() {
    return {
      body: '',
      isLoading: true,
    };
  },
  created() {
    axios({ url: endpoints.page('info') })
      .then(({ data }) => {
        this.body = data.Body;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/helpers';
@import 'src/scss/_breakpoint';

.container-fluid {
  text-align: center;
}
</style>
